import React from "react";
import styled from "styled-components";

const HeaderStyles = styled.header`
  width: 100%;
  text-align: center;
  margin-bottom: 0.5em;
  h1 {
  }
`;

function Header() {
  return (
    <HeaderStyles>
      <h1>Path to points</h1>
      <p>SVG path to CSS clip-path converter</p>
    </HeaderStyles>
  );
}

export default Header;
